import React, { memo } from "react";
import cx from "classnames";

import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

import { IOfferTagProps, OfferTagBgClass } from "./types";

import { OFFER_TAG } from "@swiggy-private/payment-test-ids";

import styles from "./OfferTag.scss";

const OfferTag = ({ iconEl, title, bgColor }: IOfferTagProps) => (
    <div className={styles.container} data-testid={OFFER_TAG.CONTAINER}>
        <div
            className={cx(styles.content, {
                [styles.offerPack]: bgColor === OfferTagBgClass.OFFER_BUNDLE,
                [styles.milestoneUnlocked]: bgColor === OfferTagBgClass.HABIT_FORMING_MILESTONE_UNLOCKED,
            })}
        >
            {iconEl}
            <Text variant="V2.body2.neutral.bold">{title}</Text>
        </div>
    </div>
);

export default memo(OfferTag);
